/** Service cards on /services — “Show example work” opens a lightbox; `caption` labels Before/After (or completed-only shots). */
export const SERVICE_WORK_CARDS = [
  {
    id: 'hardscape',
    title: 'Hardscape',
    description:
      'Patio, retaining wall, walkways—planned and built for drainage, grade, and lasting use.',
    workSlides: [
      {
        src: '/images/before_wall.jpg',
        alt: 'Retaining wall project before completion',
        caption: 'Before',
      },
      {
        src: '/images/after_wall.jpg',
        alt: 'Retaining wall project after completion',
        caption: 'After',
      },
    ],
  },
  {
    id: 'design',
    title: 'Design & install',
    description: 'New beds, mulch, plantings, and neat edges tailored to your property and soil.',
    workSlides: [
      {
        src: '/images/before_trim.jpg',
        alt: 'Shrubs and hedges before trimming',
        caption: 'Before',
      },
      {
        src: '/images/after_trim.jpg',
        alt: 'Same beds after professional bush trimming',
        caption: 'After',
      },
    ],
  },
  {
    id: 'lawn',
    title: 'Lawn & maintenance',
    description:
      'Striped mowing, trimming, and routine upkeep so turf and borders stay dialed in.',
    workSlides: [
      {
        src: '/images/before_grass2.jpg',
        alt: 'Lawn before mowing',
        caption: 'Before',
      },
      {
        src: '/images/after_grass2.jpg',
        alt: 'Lawn after mowing — striped finish',
        caption: 'After',
      },
      {
        src: '/images/lawn1.jpg',
        alt: 'Completed lawn — healthy turf and clean edges',
        caption: 'Completed work',
      },
      {
        src: '/images/lawn2.jpg',
        alt: 'Completed lawn — striped mowing finish',
        caption: 'Completed work',
      },
      {
        src: '/images/lawn3.jpg',
        alt: 'Completed lawn — landscaped yard',
        caption: 'Completed work',
      },
    ],
  },
  {
    id: 'seasonal',
    title: 'Seasonal',
    description:
      'Spring and fall cleanups, leaf removal, and prep so the yard looks its best year-round.',
    workSlides: [
      {
        src: '/images/before_rake.jpg',
        alt: 'Yard cleanup before cleanup and raking',
        caption: 'Before',
      },
      {
        src: '/images/after_rake.jpg',
        alt: 'Yard after cleanup and clean up and raking',
        caption: 'After',
      },
    ],
  },
];
